import { useState } from "react";
import axios from "axios";

const apiUtils = () => {
  const [loading, setLoading] = useState(false);

  const baseUrl = window.APP_URL;

  const skyboxUrl = "https://skybox.playbook365.com/api/";

  const sendRequest = (method, url, data = {}, config = {}, isUrl = false) => {
    setLoading(true);

    let requestUrl = `${baseUrl}${url}`;
    let requestConfig = { ...config };

    if (isUrl) {
      requestUrl = `${skyboxUrl}${url}`;
      requestConfig = {
        ...requestConfig,
        auth: {
          username: "95c23191-3d8f-4b56-ace2-bd971fdfe92b",
          password: "75f404c1-4316-4703-a228-628bb473734d",
        },
      };
    }

    return new Promise((resolve, reject) => {
      axios
        .request({
          method,
          url: requestUrl,
          data,
          ...requestConfig,
        })
        .then((response) => {
          setLoading(false);
          resolve({ data: response.data });
        })
        .catch((err) => {
          setLoading(false);
          console.error(`Unable to complete the ${method} request`, err);
          reject({ data: null, error: err });
        });
    });
  };

  const sendGETRequest = (url, config = {}, isUrl = false) => {
    return sendRequest("get", url, null, config, isUrl);
  };
  const sendPOSTRequest = (url, data = {}, config = {}, isUrl = false) => {
    return sendRequest("post", url, data, config, isUrl);
  };

  const sendPUTRequest = (url, data = {}, config = {}) => {
    return sendRequest("put", url, data, config);
  };

  const sendPATCHRequest = (url, data = {}, config = {}) => {
    return sendRequest("patch", url, data, config);
  };

  const sendDELETERequest = (url, config = {}) => {
    return sendRequest("delete", url, null, config);
  };

  return {
    loading,
    sendGETRequest,
    sendPOSTRequest,
    sendPUTRequest,
    sendPATCHRequest,
    sendDELETERequest,
  };
};

export default apiUtils;
